<template>
    <!DOCTYPE html><html>
      <head></head>
        <body style="font-family: 'Montserrat', sans-serif; color: #000000 !important;">
          <pre style="padding-bottom: 8px; font-family: 'Montserrat', sans-serif; font-size: 34px; font-weight:900; text-align: center; text-transform: uppercase;">Arqueo Cajero</pre>
          <table style="border-collapse: collapse; width: 100%; font-size: 32px; text-align: left;">  
            <tr>    
              <th style="padding: 2px; padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: white; color: #000000;"></th>
              <th style="padding: 2px; padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: white; color: #000000;"></th> 
            </tr> 
            <tr>    
              <td style="padding: 2px; font-weight:600;">Agencia:</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{arqueo.agencia_seleccionada.nombre}}</td>  
            </tr>   
            <tr>    
              <td style="padding: 2px; font-weight:600;">Momento inicio:</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{arqueo.fecha_inicio | moment('DD-MM-YYYY HH:mm:ss')}}</td>  
            </tr> 
            <tr>    
              <td style="padding: 2px; font-weight:600;">Momento fin:</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{arqueo.fecha_fin | moment('DD-MM-YYYY HH:mm:ss')}}</td>  
            </tr>   
            <tr>    
              <td style="padding: 2px; font-weight:600;">Impreso por:</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{user.username}}</td>  
            </tr>  
            <tr>    
              <td style="padding: 2px; font-weight:600;">Emitido en:</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{arqueo.emitido | moment('DD-MM-YYYY HH:mm')}}</td>  
            </tr>
            <tr v-if="arqueo.usuario != null">    
              <td style="padding: 2px; font-weight:600;">Cajero(a):</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{ arqueo.usuario.name+' '+arqueo.usuario.last_name }}</td>  
            </tr>
            <tr>    
              <td style="padding: 2px; font-weight:600;">Firma responsable: </td>
              <td style="border: 1px solid #ddd;  padding: 8px;">_________________________</td>  
            </tr>
          </table>

        
          <table v-if="tipo === 'Arqueo'" style="border-collapse: collapse; width: 100%; font-size: 28px; text-align: left;">
            <tr>    
              <td style="padding: 2px; text-transform: uppercase; font-weight:900;">Ingresos totales: </td>
              <td style="padding: 2px;"></td>  
            </tr>
            <tr v-if="consulta.ingresos_efectivo_mxn.length > 0">    
              <td style="padding: 2px; font-weight:600;">Efectivo</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{Number(consulta.ingresos_efectivo_mxn[0].monto).toFixed(2)}}</td>  
            </tr>
            <!--
            <tr v-if="consulta.ingresos_efectivo_usd_mxn.length > 0">    
              <td style="padding: 2px; font-weight:600;">Efectivo USD</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{Number(consulta.ingresos_efectivo_usd_mxn[0].monto).toFixed(2)}}</td>  
            </tr>
            -->
            <tr v-if="consulta.ingresos_tarjeta.length > 0">    
              <td style="padding: 2px; font-weight:600;">Tarjeta</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{Number(consulta.ingresos_tarjeta[0].monto).toFixed(2)}}</td>  
            </tr>
            <!--
            <tr v-if="consulta.ingresos_deposito.length > 0">    
              <td style="padding: 2px; font-weight:600;">Deposito</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{Number(consulta.ingresos_deposito[0].monto).toFixed(2)}}</td>  
            </tr>
            -->
          </table>


          <div v-if="tipo === 'Arqueo'">          
            <p style="border-collapse: collapse; width: 100%; font-size: 28px; padding: 2px; text-transform: uppercase; font-weight:900;">Movimientos de Egresos</p>
            <table v-if="consulta.detalle_egresos.length > 0" style="border-collapse: collapse; width: 100%; font-size: 28px; text-align: left;">  
              <tr>
                <th style="font-weight: 700; padding: 2px; padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: white; color: #000000;">Detalles</th>    
                <th style="font-weight: 700; padding: 2px; padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: white; color: #000000;">Monto</th>     
              </tr> 
              <tr v-for="egreso in consulta.detalle_egresos" :key="egreso.id">    
                <td style="padding:2px; text-transform: uppercase; font-weight: 600;">{{egreso.detalles}}</td>
                <td style="padding:2px; text-transform: uppercase; font-weight: 600;">{{egreso.monto}}</td>  
              </tr>    
            </table>
            <p v-else style="border-collapse: collapse; width: 100%; font-size: 28px; padding: 2px; text-transform: uppercase; font-weight:900;">Sin detalles de egresos</p>
            <p style="align:center; border-collapse: collapse; width: 100%; font-size: 28px; padding: 2px; font-weight:700;">Total de egresos: ${{Number(consulta.egresos[0].monto).toFixed(2)}}</p>
            <span style="align:center; border-collapse: collapse; width: 100%; font-size: 28px; padding: 2px; font-weight:700;">Total Efectivo MXN en Caja: ${{(Number(consulta.ingresos_efectivo_mxn[0].monto) - Number(consulta.egresos[0].monto)).toFixed(2)}}</span>
          </div>

          <div v-if="tipo != 'Arqueo'">
            <p style="border-collapse: collapse; width: 100%; font-size: 28px; padding: 2px; text-transform: uppercase; font-weight:900;">Movimientos de Ingresos {{ tipo }}</p>
            <div v-if="tipo === 'Efectivo'">
              <table v-if="consulta.impresion_ingresos_efectivo_mxn.length > 0" style="border-collapse: collapse;  width: 100%; text-align: left;">  
                <tr>    
                  <th style="font-weight: 700; font-size: 18px; padding: 2px; padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: white; color: #000000;">Detalles</th>
                  <th style="font-weight: 700; font-size: 18px; padding: 2px; padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: white; color: #000000;">Monto</th>  
                </tr> 
                <tr v-for="ingreso in consulta.impresion_ingresos_efectivo_mxn" :key="ingreso.id">    
                  <td style="padding:2px; text-transform: uppercase; font-weight: 700; font-size: 17px;">{{ingreso.detalles}}</td>
                  <td style="padding:2px; text-transform: uppercase; font-weight: 700; font-size: 17px;">{{ingreso.efectivo_mxn}}</td>  
                </tr>    
              </table>
              <p style="align:center; border-collapse: collapse;  width: 100%; font-size: 24px; font-weight: 800; padding: 8px;">Total: ${{ calculateTotal }}</p>
            </div>
            <!--
            <div v-if="tipo === 'Efectivo USD'">
              <table v-if="consulta.impresion_ingresos_efectivo_usd.length > 0" style="border-collapse: collapse;  width: 100%; text-align: left;">  
                <tr>    
                  <th style="font-weight: 700; font-size: 18px; padding: 2px; padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: white; color: #000000;">Detalles</th>
                  <th style="font-weight: 700; font-size: 18px; padding: 2px; padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: white; color: #000000;">Monto</th>  
                </tr> 
                <tr v-for="ingreso in consulta.impresion_ingresos_efectivo_usd" :key="ingreso.id">    
                  <td style="font-weight: 700; font-size: 17px; padding:2px; text-transform: uppercase;">{{ingreso.detalles}}</td>
                  <td style="font-weight: 700; font-size: 17px;padding:2px; text-transform: uppercase;">{{ingreso.efectivo_usd}}</td>  
                </tr>    
              </table>
              <p style="align:center; border-collapse: collapse;  width: 100%; font-size: 22px; padding: 8px;">Total: ${{ calculateTotal }}</p>
            </div>
            -->
            <div v-if="tipo === 'Tarjeta'">
              <table v-if="consulta.impresion_ingresos_tarjeta.length > 0" style="border-collapse: collapse;  width: 100%; text-align: left;">  
                <tr>    
                  <th style="font-weight: 700; padding: 2px; padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: white; color: #000000;">Detalles</th>
                  <th style="font-weight: 700; padding: 2px; padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: white; color: #000000;">Monto</th>  
                </tr> 
                <tr v-for="ingreso in consulta.impresion_ingresos_tarjeta" :key="ingreso.id">    
                  <td style="padding:2px; text-transform: uppercase; font-weight: 700; font-size: 17px;">{{ingreso.detalles}}</td>
                  <td style="padding:2px; text-transform: uppercase; font-weight: 700; font-size: 17px;">{{ingreso.tarjeta}}</td>  
                </tr>    
              </table>
              <p style="align:center; border-collapse: collapse;  width: 100%; font-size: 24px; font-weight: 800; padding: 8px;">Total: ${{ calculateTotal }}</p>
            </div>
            <!---
            <div v-if="tipo === 'Depósito a Cuenta'">
              <table v-if="consulta.impresion_ingresos_deposito.length > 0" style="border-collapse: collapse; width: 100%; text-align: left;">  
                <tr>    
                  <th style="font-weight: 700; padding: 2px; padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: white; color: #000000;">Detalles</th>
                  <th style="font-weight: 700; padding: 2px; padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: white; color: #000000;">Monto</th>  
                </tr> 
                
                <tr v-for="ingreso in consulta.impresion_ingresos_deposito" :key="ingreso.id">    
                  <td style="padding:2px; text-transform: uppercase; font-weight: 700; font-size: 17px;">{{ingreso.detalles}}</td>
                  <td style="padding:2px; text-transform: uppercase; font-weight: 700; font-size: 17px;">{{ingreso.deposito}}</td>  
                </tr>   
                
              </table>
              <p style="align:center; border-collapse: collapse;  width: 100%; font-size: 24px; font-weight: 800; padding: 8px;">Total: ${{ calculateTotal }}</p>
            </div>
            --> 
          </div>
        </body>
      </html>
</template>
<script>
export default {
  props: {
    arqueo: {required: false},
    consulta: {required: false},
    user: {required: false},
    tipo: {required: false}
  },

  data() {
      return {
       
      };
    },

  mounted(){
    //const date = new Date();
    //this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
  },
  computed: {
    calculateTotal(){
      var total = 0;
      if(this.tipo === 'Efectivo'){
        for(let i=0; i < this.consulta.impresion_ingresos_efectivo_mxn.length; i++){
          total = total + Number(this.consulta.impresion_ingresos_efectivo_mxn[i].efectivo_mxn)
        }
      }
      /*
      if(this.tipo === 'Efectivo USD'){
        for(let i=0; i < this.consulta.impresion_ingresos_efectivo_usd.length; i++){
          total = total + Number(this.consulta.impresion_ingresos_efectivo_usd[i].efectivo_usd)
        }
      }
      */
      if(this.tipo === 'Tarjeta'){
        for(let i=0; i < this.consulta.impresion_ingresos_tarjeta.length; i++){
          total = total + Number(this.consulta.impresion_ingresos_tarjeta[i].tarjeta)
        }
      }
      /*
      if(this.tipo === 'Depósito a Cuenta'){
        for(let i=0; i < this.consulta.impresion_ingresos_deposito.length; i++){
          total = total + Number(this.consulta.impresion_ingresos_deposito[i].deposito)
        }
      }
      */
      return total.toFixed(2);
    }
  },
}
</script>
<style scoped> 
</style>